var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import classNames from 'clsx';
import format from 'date-fns/format';
import isPast from 'date-fns/isPast';
import DatePicker from 'react-date-picker';
import { getDateFnsLocaleDateFormat } from '../../util-components/datetime';
import { DATE_FORMAT_FOR_DB } from '../../constants/constants';
import Icon from '../icon';
import { Styled } from './style';
var CustomDaterangePicker = /** @class */ (function (_super) {
    __extends(CustomDaterangePicker, _super);
    function CustomDaterangePicker(props) {
        var _a, _b, _c, _d;
        var _this = _super.call(this, props) || this;
        _this.handleStartDateChange = function (value) { return __awaiter(_this, void 0, void 0, function () {
            var formatStartDate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formatStartDate = format(new Date(value), DATE_FORMAT_FOR_DB);
                        return [4 /*yield*/, this.setState({
                                start: formatStartDate,
                                isEndDatePickerOpen: true,
                            })];
                    case 1:
                        _a.sent();
                        this.props.onChange && this.props.onChange({
                            start: this.state.start,
                            end: this.state.isEndDateSet ? this.state.end : '',
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleEndDateChange = function (value) { return __awaiter(_this, void 0, void 0, function () {
            var formatEndDate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formatEndDate = format(new Date(value), DATE_FORMAT_FOR_DB);
                        return [4 /*yield*/, this.setState({
                                end: formatEndDate,
                                isEndDatePickerOpen: false,
                                isEndDateSet: true,
                            })];
                    case 1:
                        _a.sent();
                        this.props.onChange && this.props.onChange({
                            start: this.state.start,
                            end: this.state.end,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleEndDateOpen = function () {
            if (_this.state.end === '') {
                _this.setState({
                    end: _this.state.start,
                });
            }
            if (!_this.state.isEndDateSet && _this.state.end === '') {
                var domNode = _this.endDateRef.current;
                var divider = domNode.querySelectorAll('.react-date-picker__inputGroup__divider');
                divider[1].style.visibility = 'hidden';
                divider[1].innerText = '';
                var endDatePlaceholder = domNode.querySelector('.react-date-picker__inputGroup__divider');
                endDatePlaceholder.innerText = 'End Date';
                endDatePlaceholder.style.zIndex = '0';
                var endDateInput = domNode.querySelector('.react-date-picker__inputGroup__year');
                endDateInput.style.position = 'absolute';
                endDateInput.style.minWidth = '100%';
                endDateInput.style.top = '0';
                endDateInput.style.left = '0';
                endDateInput.style.zIndex = '1';
                endDateInput.style.opacity = '0.01';
            }
        };
        _this.handleEndDateClose = function () {
            var domNode = _this.endDateRef.current;
            var endDatePlaceholder = domNode.querySelector('.react-date-picker__inputGroup__divider');
            if (_this.state.isEndDateSet) {
                var divider = domNode.querySelectorAll('.react-date-picker__inputGroup__divider');
                divider[1].style.visibility = 'visible';
                divider[1].innerText = '/';
                endDatePlaceholder.innerText = '/';
                endDatePlaceholder.style.zIndex = '';
                var endDateInput = domNode.querySelector('.react-date-picker__inputGroup__year');
                endDateInput.style.position = '';
                endDateInput.style.minWidth = '';
                endDateInput.style.top = '';
                endDateInput.style.left = '';
                endDateInput.style.zIndex = '';
                endDateInput.style.opacity = '';
            }
            else {
                endDatePlaceholder.innerText = 'Indefinite';
            }
        };
        _this.getMinStartDate = function () {
            var _a = _this.props, disablePastDateSelection = _a.disablePastDateSelection, value = _a.value;
            var startDate = value.start && value.start !== '' ? new Date(value.start + 'T00:00:00') : undefined;
            var isStartDatePast = startDate ? isPast(startDate) : false;
            if (!disablePastDateSelection) {
                return undefined;
            }
            var minStartDate = isStartDatePast ? startDate : new Date();
            return minStartDate;
        };
        _this.endDateRef = React.createRef();
        _this.state = {
            value: props.value,
            start: (_a = props.value) === null || _a === void 0 ? void 0 : _a.start,
            end: (_b = props.value) === null || _b === void 0 ? void 0 : _b.end,
            isEndDatePickerOpen: false,
            isEndDateSet: ((_c = props.value) === null || _c === void 0 ? void 0 : _c.end) !== undefined && ((_d = props.value) === null || _d === void 0 ? void 0 : _d.end) !== '',
        };
        return _this;
    }
    CustomDaterangePicker.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.value !== prevState.value) {
            return {
                value: nextProps.value,
            };
        }
        return null;
    };
    CustomDaterangePicker.prototype.componentDidUpdate = function (prevProps, prevState) {
        var endDate = this.state.end ? new Date(this.state.end).getTime() : '';
        var startDate = this.state.start ? new Date(this.state.start).getTime() : '';
        if (this.state.end !== '' && startDate > endDate) {
            this.setState({
                end: this.state.start,
                isEndDatePickerOpen: true,
            });
        }
    };
    CustomDaterangePicker.prototype.render = function () {
        var _a = this.props, className = _a.className, compact = _a.compact, disabled = _a.disabled, locale = _a.locale, isOpen = _a.isOpen;
        var _b = this.state, value = _b.value, end = _b.end, isEndDatePickerOpen = _b.isEndDatePickerOpen, isEndDateSet = _b.isEndDateSet;
        var startDate = value.start && value.start !== '' ? new Date(value.start + 'T00:00:00') : undefined;
        var endDate = value.end && value.end !== '' ? new Date(value.end + 'T00:00:00') : undefined;
        return (React.createElement(Styled, { className: className, compact: compact, disabled: disabled },
            React.createElement("div", { className: classNames("daterange-picker__wrapper", (end && isEndDateSet) ? "has-end-date" : "no-end-date") },
                React.createElement(DatePicker, { className: classNames("react-date-picker__start", startDate === undefined ? 'react-date-picker__empty' : ''), clearIcon: null, isOpen: isOpen, dayPlaceholder: "Start Date", disabled: disabled, format: getDateFnsLocaleDateFormat(locale), locale: locale, minDate: this.getMinStartDate(), onChange: this.handleStartDateChange, nextLabel: React.createElement(Icon, { name: "arrow-right" }), prevLabel: React.createElement(Icon, { name: "arrow-left" }), value: startDate, minDetail: "year" }),
                React.createElement("div", { className: "path" }, "-"),
                React.createElement("span", { ref: this.endDateRef },
                    React.createElement(DatePicker, { className: classNames("react-date-picker__end", (endDate === undefined || end === '') && 'react-date-picker__empty'), clearIcon: null, dayPlaceholder: startDate === undefined ? "End Date" : "Indefinite", disabled: disabled || startDate === undefined, minDate: startDate, format: getDateFnsLocaleDateFormat(locale), locale: locale, onChange: this.handleEndDateChange, onCalendarClose: this.handleEndDateClose, onCalendarOpen: this.handleEndDateOpen, value: endDate, required: false, isOpen: isEndDatePickerOpen, nextLabel: React.createElement(Icon, { name: "arrow-right" }), prevLabel: React.createElement(Icon, { name: "arrow-left" }), minDetail: "year" })))));
    };
    return CustomDaterangePicker;
}(React.Component));
export default CustomDaterangePicker;
//# sourceMappingURL=index.js.map